export default {
    TOKEN: "token",
};
